import Swiper from '../lib/swiper'

class HighlightsSlider {
  constructor() { 
    

    const swiper = new Swiper('.ns-highlights-container', {
      // slideClass: 'ns-highlights-item',
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      parallax: true,
      spaceBetween: 30,

      // loop:true,

      navigation: {
        nextEl: '.ns-highlights-container-next',
        prevEl: '.ns-highlights-container-prev',
      },

      pagination: {
        el: '.ns-highlights-container__pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          return '<span class="ns-highlight-fraction">' + current + '</span><span class="ns-highlight-fraction">' + total + '</span>';
        }
      }
    });

    document.querySelectorAll('.ns-highlights-item').forEach(item => {
      item.addEventListener('click', (e) => {
        console.log(e.target.tagName)
        if (e.target.tagName != 'A') {
          item.classList.toggle('active');
        }
      });
    });
  }

} export default HighlightsSlider;